/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZD0iTTAuNSAwLjVWMTUuNUgxNS41VjAuNUgwLjVaTTE0LjUgMS41VjUuMTdIMS41VjEuNUgxNC41Wk02LjE3IDkuODNWNi4xN0g5LjgzVjkuODNINi4xN1pNOS44NCAxMC44M1YxNC41SDYuMTdWMTAuODNIOS44NFpNNS4xNyA5LjgzSDEuNVY2LjE3SDUuMTdWOS44M1pNMTAuODQgNi4xNkgxNC41VjkuODNIMTAuODNMMTAuODQgNi4xNlpNMS41IDEwLjgzSDUuMTdWMTQuNUgxLjVWMTAuODNaTTEwLjgzIDE0LjVWMTAuODNIMTQuNVYxNC41SDEwLjgzWiIgZmlsbD0iaW5oZXJpdCIvPg==";